import { render } from "./ErrorBlock.vue?vue&type=template&id=21700014&scoped=true"
const script = {}

import "./ErrorBlock.vue?vue&type=style&index=0&id=21700014&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21700014"]])

export default __exports__